<div class="login-page" data-bs-theme="dark">
  <div class="login-container">
    <!-- Logo and Header -->
    <div class="text-center mb-4">
      <img [src]="logo" alt="ADN Logo" class="login-logo" />
      <h2 class="h3 mb-2">Reset Password</h2>
      <p class="text-muted">Enter your new password for: <b>{{ email }}</b></p>
    </div>

    @if (errorMessage) {
      <div class="alert alert-danger" role="alert">
        <i class="bi bi-exclamation-triangle me-2"></i>
        {{ errorMessage }}
      </div>
    }

    <div>
      <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
        <!-- New Password -->
        <div class="mb-3">
          <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              [type]="showPassword ? 'text' : 'password'"
              class="form-control"
              id="password"
              formControlName="password"
              placeholder="Create a strong password"
              [class.is-invalid]="resetForm.get('password')?.invalid && resetForm.get('password')?.touched"
              autocomplete="new-password"
            />
            <button class="btn btn-outline-secondary" type="button" (click)="togglePasswordVisibility()">
              <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
            </button>
          </div>
          @if (passwordErrors.length > 0) {
            <div class="invalid-feedback d-block">
              @for (error of passwordErrors; track error) {
                <div>{{ error }}</div>
              }
            </div>
          }
        </div>

        <!-- Confirm Password -->
        <div class="mb-3">
          <label for="confirmPassword" class="form-label">Confirm Password <span class="text-danger">*</span></label>
          <div class="input-group">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              class="form-control"
              id="confirmPassword"
              formControlName="confirmPassword"
              placeholder="Re-enter your password"
              [class.is-invalid]="(resetForm.get('confirmPassword')?.invalid && resetForm.get('confirmPassword')?.touched) || (resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched)"
              autocomplete="new-password"
            />
            <button class="btn btn-outline-secondary" type="button" (click)="toggleConfirmPasswordVisibility()">
              <i [class]="showConfirmPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
            </button>
          </div>
          @if (resetForm.hasError('passwordMismatch') && resetForm.get('confirmPassword')?.touched) {
            <div class="invalid-feedback d-block">Passwords do not match</div>
          }
        </div>

        <button
          type="submit"
          class="btn btn-primary w-100 mt-3"
          [disabled]="loading || resetForm.invalid"
        >
          @if (loading) {
            <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
          }
          {{ loading ? 'Resetting Password...' : 'Confirm Password Reset' }}
        </button>

        <div class="text-center mt-3">
          <button
            type="button"
            class="btn btn-link p-0"
            (click)="goBackToLogin()"
            [disabled]="loading"
          >
            <i class="bi bi-arrow-left me-2"></i>
            Back to Login
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
